import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=330cd35a&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=330cd35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330cd35a",
  null
  
)

export default component.exports